import { faHome } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import CustomButton from "../common/CustomButton";

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-300 to-teal-300">
            <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
            <p className="text-2xl font-semibold text-gray-600 mb-8">Oops! Page Not Found</p>
            <div className="w-16 h-1 bg-gray-800 mb-8"></div>
            <p className="text-gray-600 mb-8 text-center max-w-lg">
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
            </p>
            <CustomButton
                size="large"
                className="flex items-center rounded-full bg-gray-800 !text-white hover:!bg-gray-700 hover:!border-gray-800 transition-colors duration-300"
                onClick={() => navigate("/")}
            >
                <FontAwesomeIcon icon={faHome} />
                Go Home
            </CustomButton>
        </div>
    )
}

export default NotFoundPage;